import React from 'react';

import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";

import { FormInputCheckbox, FormInputDatePicker } from "../../../ReactHookForm/FormComponents";

const HookSubFormStatutoryReferral = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const isReferred = watch(sectionName + '.statutory_referral_flag')

    return (
        <FieldsetContainer title='Statutory Referral' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormInputCheckbox readOnly={readOnly} label='Has there been a referral for statutory assessment?' sectionName={sectionName} name={'statutory_referral_flag'} register={register}/>
                </BootstrapCol>
            </BootstrapRow>

            <BootstrapRow>
                { isReferred === true && <BootstrapCol width={6}>
                    <FormInputDatePicker readOnly={readOnly} label='Statutory Assessment Referral Date' sectionName={sectionName} name={'dmy_statutory_referral_date'} control={control} required={true} formErrors={formErrors}/>
                </BootstrapCol> }
                { isReferred === false && <BootstrapCol width={6}></BootstrapCol> }

                { isReferred === true &&  <BootstrapCol width={6}>
                    <FormInputDatePicker readOnly={readOnly} label='20 week date' sectionName={sectionName} name={'dmy_sr_proposed_end_date'} control={control} required={true} formErrors={formErrors}/>
                </BootstrapCol> }
                { isReferred === false && <BootstrapCol width={6}></BootstrapCol> }
            </BootstrapRow>
        </FieldsetContainer>
    )
}

export default HookSubFormStatutoryReferral;
